module.exports = __webpack_public_path__ + "static/media/icon-manual-track.4657820b.svg";